<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark" style="background: #a7311f !important">
    <div class="container">
      <a class="navbar-brand d-lg-none" href="#">Agenda</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <router-link
            tag="li"
            class="nav-item text-center"
            :class="{'active' :$route.params.day === 19}"
            :to="{ name: 'grid', params: {language: $route.params.language, day:19} }"
          >
            <a class="nav-link">
              <i class="fas fa-microphone"></i> 19/10
            </a>
          </router-link>
          <router-link
            tag="li"
            class="nav-item text-center"
            :class="{'active' :$route.params.day === 20}"
            :to="{ name: 'grid', params: {language: $route.params.language, day:20} }"
          >
            <a class="nav-link">
              <i class="fas fa-microphone"></i> 20/10
            </a>
          </router-link>
          <router-link
            tag="li"
            class="nav-item text-center"
            :class="{'active' :$route.params.day === 21}"
            :to="{ name: 'grid', params: {language: $route.params.language, day:21} }"
          >
            <a class="nav-link">
              <i class="fas fa-microphone"></i> 21/10
            </a>
          </router-link>
          <router-link
            tag="li"
            class="nav-item text-center"
            :class="{'active' :$route.params.day === 22}"
            :to="{ name: 'grid', params: {language: $route.params.language, day:22} }"
          >
            <a class="nav-link">
              <i class="fas fa-microphone"></i> 22/10
            </a>
          </router-link>
          <!-- <router-link
            tag="li"
            class="nav-item text-center"
            :class="{'active' :$route.params.day === 31}"
            :to="{ name: 'grid', params: {language: $route.params.language, day:31} }"
          >
            <a class="nav-link">
              <i class="fas fa-microphone"></i> 31/10
            </a>
          </router-link>-->

          <!-- <li class="nav-item text-center">
            <a class="nav-link" :href="'http://informa-congress.pixel3.solutions/pdf/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/slots-day/'+$route.params.day+'/'+$route.params.language" target="_blank">
              <i class="fas fa-file-pdf"></i>
              PDF
            </a>
          </li>-->
          <li class="nav-item text-center">
            <a class="nav-link" href="https://www.fispalfoodservice.com.br" target="_blank">
              <i class="fas fa-link"></i>
              <span v-if="$route.params.language === 'pt'">Site Oficial</span>
              <span v-if="$route.params.language === 'en'">Official Site</span>
            </a>
          </li>
        </ul>
        <!-- <div class="btn btn-info btn-signin" data-toggle="tooltip" data-placement="top" title="Faça login para criar sua agenda personalizada!">
          <i class="fas fa-key"></i> Logar
        </div>-->
        <!-- <form class="form-inline my-2 my-lg-0">
          <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
        </form>-->
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "Nav",
  data() {
    return {
      days: {},
      daysWeek: {
        pt: {
          d15: "Segunda feira",
          d16: "Terça feira",
          d17: "Quarta feira",
          d18: "Quinta feira"
        },
        en: {
          d15: "Monday",
          d16: "Terça feira",
          d17: "Quarta feira",
          d18: "Quinta feira"
        },
        es: {
          d15: "Segunda feira",
          d16: "Terça feira",
          d17: "Quarta feira",
          d18: "Quinta feira"
        }
      }
    };
  }
};
</script>

<style scoped>
.nav-f {
  border-top: solid 1px #4fffff;
  background: #1d4e89;
}
@media (max-width: 1199.98px) {
  .btn-signin {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Nav.vue